import * as $runtime from "../runtime.js";
import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dDateTime from "../Data.DateTime/index.js";
import * as Data$dDateTime$dInstant from "../Data.DateTime.Instant/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dNonEmpty from "../Data.NonEmpty/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Effect$dNow from "../Effect.Now/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Unscramble from "../Unscramble/index.js";
const UTCTime = x => x;
const unscrambleDecodeUTCTime = {
  unsafeDecode: value => {
    const str = Unscramble.decodeString(value);
    const v = DateUtils.parseISODateTime(str);
    if (v.tag === "Just") { return v._1; }
    if (v.tag === "Nothing") { return Unscramble.decodingError("Invalid ISO8601 datetime: " + Data$dShow.showStringImpl(str)); }
    $runtime.fail();
  }
};
const ordUTCTime = Data$dDateTime.ordDateTime;
const now = dictMonadEffect => dictMonadEffect.liftEffect(() => {
  const a$p = Effect$dNow.now();
  return Data$dDateTime$dInstant.toDateTime(a$p);
});
const newtypeUTCTime = {Coercible0: () => {}};
const showUTCTime = {show: x => DateUtils.formatISODateTime(x)};
const toUnixTimestamp = x => Data$dDateTime$dInstant.fromDateTime(x);
const genericUTCTime = {to: x => x, from: x => x};
const fromUTCTime = v => v;
const eqUTCTime = Data$dDateTime.eqDateTime;
const encodeUTCTime = {encode: x => DateUtils.formatISODateTime(x)};
const decodeUTCTime = {
  decode: value => Control$dMonad$dExcept$dTrans.bindExceptT(Data$dIdentity.monadIdentity).bind(Foreign.unsafeReadTagged(Data$dIdentity.monadIdentity)("String")(value))(str => {
    const v = DateUtils.parseISODateTime(str);
    if (v.tag === "Just") { return Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure(v._1); }
    if (v.tag === "Nothing") {
      return Control$dMonad$dExcept$dTrans.monadThrowExceptT(Data$dIdentity.monadIdentity).throwError(Data$dNonEmpty.$NonEmpty(
        Foreign.$ForeignError("ForeignError", "Invalid ISO8601 datetime: " + Data$dShow.showStringImpl(str)),
        Data$dList$dTypes.Nil
      ));
    }
    $runtime.fail();
  })
};
const boundedUTCTime = Data$dDateTime.boundedDateTime;
export {
  UTCTime,
  boundedUTCTime,
  decodeUTCTime,
  encodeUTCTime,
  eqUTCTime,
  fromUTCTime,
  genericUTCTime,
  newtypeUTCTime,
  now,
  ordUTCTime,
  showUTCTime,
  toUnixTimestamp,
  unscrambleDecodeUTCTime
};
